import { ComponentType } from '@angular/cdk/portal';
import { InjectionToken } from '@angular/core';
import { ShipmentSummaryComponentType } from '../types/shipment-summary-component-type.interface';

export const SHIPMENT_SUMMARY_COMPONENT_TYPE = new InjectionToken<ComponentType<ShipmentSummaryComponentType>>(
  'SHIPMENT_SUMMARY_COMPONENT_TYPE'
);
